import { Button } from 'app/components/Button';
import { logoutUser } from 'lib/utils/authentication';
import React, { VFC } from 'react';
import { Div } from 'styles/__layout';

interface Props {
  error: Error;
  retry: () => void;
}

export const DefaultErrorFallback: VFC<Props> = ({ error, retry }) => (
  <Div style={{ padding: 10 }}>
    <h1>{error.name}</h1>
    <pre>{error.message}</pre>
    <Div style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
      <Button onClick={retry}>Retry</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => logoutUser()}>
        Login again
      </Button>
    </Div>
  </Div>
);
